// extracted by mini-css-extract-plugin
export default {"wrapper":"_ba9640e0","closed":"_ab5a7a41","cta":"_abaa2fe5"};